import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Gift, Sparkles } from 'lucide-react';
export function FreeOfferReveal() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-black overflow-hidden" data-id="element-1051">
      <motion.div ref={ref} initial={{
      opacity: 0,
      scale: 0.9
    }} animate={inView ? {
      opacity: 1,
      scale: 1
    } : {}} transition={{
      duration: 0.8
    }} className="relative z-10 max-w-5xl mx-auto" data-id="element-1052">
        <div className="relative bg-gradient-to-br from-stone-900 to-black border-2 border-amber-500/30 p-6 sm:p-10 md:p-12 rounded-xl text-center" data-id="element-1053">
          <div className="absolute -top-6 sm:-top-8 left-1/2 -translate-x-1/2 bg-black p-3 sm:p-4 rounded-full border-2 border-amber-500/50" data-id="element-1054">
            <Gift className="w-8 h-8 sm:w-12 sm:h-12 text-amber-500" data-id="element-1055" />
          </div>

          <h2 className="text-2xl sm:text-4xl md:text-5xl font-serif font-bold text-stone-100 mb-6 sm:mb-8 mt-4 sm:mt-6" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-1056">
            A Gift For PRO Members
          </h2>

          <p className="text-lg sm:text-xl md:text-2xl text-stone-300 mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-1057">
            When you join today, we're including complete access to{' '}
            <span className="text-amber-400 font-bold" data-id="element-1058">
              Peptide Mastery 2.0
            </span>{' '}
            at no additional cost.
          </p>

          <div className="inline-block px-6 sm:px-8 py-3 sm:py-4 bg-green-900/20 border border-green-500/30 rounded-lg" data-id="element-1059">
            <p className="text-green-400 font-bold text-lg sm:text-xl flex items-center gap-2 sm:gap-3" data-id="element-1060">
              <Sparkles className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-1061" />
              <span data-id="element-1062">$2,500 Value — Yours FREE</span>
            </p>
          </div>

          <div className="mt-8 sm:mt-10" data-id="element-1063">
            <button onClick={() => {
            const pricingSection = document.querySelector('[data-pricing-section]');
            if (pricingSection) {
              pricingSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }} className="inline-block px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-500 hover:to-amber-400 text-black font-bold text-lg sm:text-xl rounded-lg shadow-[0_0_30px_rgba(217,119,6,0.4)] hover:shadow-[0_0_50px_rgba(217,119,6,0.6)] hover:scale-105 transition-all duration-300 min-h-[44px]" data-id="element-1064">
              Claim Your FREE Access — Join Now
            </button>
          </div>
        </div>
      </motion.div>
    </section>;
}